// removed by extract-text-webpack-plugin
module.exports = {"text-area":"magazines_1BbHe"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/ContentEditor/editors/IframeContent/styles.scss
// module id = 1222
// module chunks = 1